import styles from "./mark-modals.styles.css";
import { markStore } from "@lib/store/src/mark";
import { ResourcesList } from "generated";
import i18next from "i18next";

export function getMarkModalTemplate(): HTMLElement {
  const modal = document.createElement("div");
  modal.className = "mark-modal";
  modal.style.zIndex = '99999999';
  modal.style.left = `${(window.innerWidth - 500) / 2}px`;
  modal.style.top = `${(window.innerHeight - 300) / 2}px`;

  const styleTag = document.createElement("style");
  styleTag.textContent = styles;
  modal.appendChild(styleTag);

  const header = document.createElement("h2");
  header.textContent = markStore.notes.length ? `${i18next.t("poster_selection")}` : `${i18next.t("mark_selection")}`;
  modal.appendChild(header);

  let isDragging = false;
  let offsetX = 0;
  let offsetY = 0;

  header.addEventListener("mousedown", (e) => {
    isDragging = true;
    const rect = modal.getBoundingClientRect();
    offsetX = e.clientX - rect.left;
    offsetY = e.clientY - rect.top;
    document.body.style.userSelect = "none";
  });

  document.addEventListener("mousemove", (e) => {
    if (isDragging) {
      modal.style.left = `${e.clientX - offsetX}px`;
      modal.style.top = `${e.clientY - offsetY}px`;
    }
  });

  document.addEventListener("mouseup", () => {
    isDragging = false;
    document.body.style.userSelect = "";
  });

  const previewList = document.createElement("div");
  previewList.className = "preview-list";
  modal.appendChild(previewList);

  const closeBtn = document.createElement("button");
  closeBtn.className = "close-btn";
  closeBtn.textContent = `${i18next.t("close")}`;
  closeBtn.addEventListener("click", () => markStore.closeModal());
  modal.appendChild(closeBtn);

  const images = ResourcesList.resourcesList;

  const renderMarks = (marks: any[]) => {
    previewList.innerHTML = "";
    marks.forEach((mark) => {
      const block = document.createElement("div");
      block.className = "preview-block";

      const resPath = images[mark.resourcename];
      if (resPath) {
        const img = document.createElement("img");
        img.src = `/resources/${resPath}`;
        img.alt = mark.name;
        img.className = "preview-image";
        img.draggable = true;
        const origin = markStore.isMarkControl ? "mark" : "poster";
        if (mark.priority >= 1 && origin === "mark") img.title = `${i18next.t("mark_priority")}: ${mark.priority}`;
        if (mark.priority >= 1 && origin === "poster") img.title = `${i18next.t("poster_priority")}: ${mark.priority}`;
        const activeControl = document.querySelector(".ms-markcontrol.opened");
        const controlId = activeControl ? activeControl.id : null;

        img.ondragstart = (e) => {
          const offsetX = e.offsetX;
          const offsetY = e.offsetY;
          e.dataTransfer?.setData("text/plain", JSON.stringify({
            resourcename: mark.resourcename,
            offsetX,
            offsetY,
            origin,
            controlId
          }));
        };

        img.onclick = () => {
          markStore.selectMark(mark);
          modal.querySelectorAll(".preview-image").forEach(el =>
            el.classList.remove("selected")
          );
          img.classList.add("selected");
        };

        block.appendChild(img);
      } else {
        const placeholder = document.createElement("div");
        placeholder.textContent = `${i18next.t("no_image")}`;
        placeholder.className = "image-placeholder";
        block.appendChild(placeholder);
      }

      const label = document.createElement("div");
      label.textContent = mark.name;
      label.className = "mark-label";
      block.appendChild(label);
      previewList.appendChild(block);
    });
  };

  if (markStore.notes && markStore.notes.length > 0) {
    const tabContainer = document.createElement("div");
    tabContainer.className = "tab-container";

    const postersTab = document.createElement("button");
    postersTab.textContent = `${i18next.t("posters")}`;
    postersTab.className = "tab-btn active";

    const notesTab = document.createElement("button");
    notesTab.textContent = `${i18next.t("dispatcher_marks")}`;
    notesTab.className = "tab-btn";

    tabContainer.appendChild(postersTab);
    tabContainer.appendChild(notesTab);
    modal.insertBefore(tabContainer, previewList);

    const showPosters = () => {
      postersTab.classList.add("active");
      notesTab.classList.remove("active");
      renderMarks(markStore.marks);
    };

    const showNotes = () => {
      notesTab.classList.add("active");
      postersTab.classList.remove("active");
      renderMarks(markStore.notes);
    };

    postersTab.onclick = showPosters;
    notesTab.onclick = showNotes;

    showPosters();
  } else {
    renderMarks(markStore.marks);
  }

  return modal;
}